<template>
  <div class="house-tree">
    <div class="house-tree-header">
      <el-button type="primary" size="mini" @click="getData()">刷新</el-button>
      <el-input
        class="filter-input"
        placeholder="输入关键字进行过滤"
        size="mini"
        v-model="filterText">
      </el-input>
    </div>
    <div class="house-tree-container">
      <el-tree
        ref="tree"
        :data="dataObject"
        node-key="house_id"
        :props="{label: 'house_name', children: 'children'}"
        :highlight-current="true"
        default-expand-all
        @node-click="nodeClick"
        :filter-node-method="filterNode"
        :expand-on-click-node="false">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div>{{ node.label }}</div>
          <div>
            <el-link
              type="primary"
              size="mini"
              @click.stop="() => append(data)">
              添加
            </el-link>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <el-link
              type="primary"
              size="mini"
              @click.stop="() => edit(data)">
              编辑
            </el-link>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <el-link
              type="danger"
              size="mini"
              @click.stop="() => remove(data)">
              移除
            </el-link>
          </div>
        </div>
      </el-tree>
    </div>
    <HouseInfoComponent ref="houseInfoComponent" />
    <HouseRelatedInfo ref="houseRelatedInfo" />
  </div>
</template>

<script>
import Http from "../Project/common/Http";
import HouseInfoComponent from "../Project/components/house/components/HouseInfoComponent";
import HouseRelatedInfo from "../Project/components/house/components/HouseRelatedInfo";

export default {
  name: "ProjectTree",
  components: {HouseRelatedInfo, HouseInfoComponent},
  props: {
    project_id: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      dataObject: [],
      filterText: "",
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const that = this;
      Http.get("HouseTree/getHouseTree",{project_id:that.project_id},ret=>{
        if(ret.code){
          that.dataObject = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    append(data) {
      const that=this;
      console.log(data)
      that.$refs.houseInfoComponent.show({
        parent_id:data.house_id,
        project_house_id:data.project_house_id,
        erp_pindex_id:data.erp_pindex_id
      },()=>{
        that.getData();
      })
    },
    remove(data) {
      const that=this;
      console.log(data)
      that.$refs.houseRelatedInfo.show(data,()=>{
        that.getData();
      })
    },
    edit(data) {
      const that=this;
      console.log(data)
      that.$refs.houseInfoComponent.show(data,()=>{
        that.getData();
      })
    },
    nodeClick(data) {
      // console.log(data);
      this.$emit("node-click", data);
    },
    filterNode(value, data) {
      if (!value) return true;
      console.log(value, data)
      return data.house_name.indexOf(value) !== -1;
    },
  },
  watch:{
    project_id(val){
      this.getData();
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
}
</script>

<style scoped lang="scss">
.house-tree{
  width: 100%;

  .house-tree-header{
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    .filter-input{
      width: calc(90% - 60px);
    }
  }

  .house-tree-container{
    height: calc(70vh - 40px);
    overflow-y: scroll;

    .custom-tree-node{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 4px 4px 10px;
      margin-top: 2px;
      margin-bottom: 2px;
      width: 100%;
      border-left: 2px solid #bcbcbc;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: -1px;
        width: 6px;
        height: 2px;
        background-color: #bcbcbc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ProjectTree.vue